import CIcon from "@coreui/icons-react";
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CModal,
  CModalBody,
  CRow,
  CSelect,
} from "@coreui/react";

import { InputGroup, Loading, ErrorAlert } from "components";
import LoginFormLogic from "./LoginForm.logic";
import { useHistory } from "react-router-dom";

import { Colors } from "utils";
import { useState } from "react";
import GetPrivateBucketMedia from "utils/getPrivateBucketMedia";

const LoginForm = () => {
  const {
    expired,
    error,
    isLoading,
    errorMsg,
    handleLogin,
    handleChange,
    handleCareHomeModel,
    handleSelectChange,
    loginData,
    openCarehomeModal,
  } = LoginFormLogic();
  const history = useHistory();
  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="8">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleLogin}>
                    <h1>Login</h1>

                    {expired ? (
                      <CAlert className="mt-3" color="info">
                        Your session has expired, please login again
                      </CAlert>
                    ) : (
                      <p className="text-muted">Sign In to your account</p>
                    )}

                    <InputGroup prepend={<CIcon name="cil-user" />}>
                      <CInput
                        type="text"
                        placeholder="Username"
                        autoComplete="username"
                        name="username"
                        onChange={handleChange}
                      />
                    </InputGroup>

                    <InputGroup prepend={<CIcon name="cil-lock-locked" />}>
                      <CInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        name="password"
                        onChange={handleChange}
                      />
                    </InputGroup>

                    <div className="text-left mb-3">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={() => history.push("/forgot-password")}
                      >
                        Forgot Password?
                      </button>
                    </div>

                    <Loading show={isLoading} />

                    <ErrorAlert errorMsg={errorMsg} show={error} margin />
                    <CButton type="submit" color="primary" disabled={isLoading}>
                      Login
                    </CButton>
                  </CForm>
                </CCardBody>
              </CCard>

              <CCard
                className="text-white py-5 d-md-down-none"
                style={{ width: "44%", background: Colors._blue }}
              >
                <CCardBody className="text-center">
                  <CIcon
                    className="c-sidebar-brand-full"
                    name="logo"
                    alt="Thrive Community: Senior Care"
                    height={85}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "53%",
                      transform: "translate(-50%, -50%)",
                    }}
                  />
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
      <CModal
        style={{ position: "absolute" }}
        show={openCarehomeModal}
        onClose={handleCareHomeModel}
      >
        <div class="d-flex justify-space-between p-3">
          <h4 className="fw-bolder">Login As</h4>
          <CIcon
            name="cil-X"
            style={{ marginLeft: "auto", cursor: "pointer" }}
            onClick={handleCareHomeModel}
          />
        </div>
        <CModalBody className={"pt-0"}>
          <hr className="my-3" />{" "}
          <h6 className="text-center"> Carehome List</h6>{" "}
          <hr className="my-3" />
          {loginData &&
            loginData?.careHomes?.length > 0 &&
            loginData?.careHomes.map((item) => {
              return (
                <div
                  value={item?.identifier}
                  key={item?.identifier}
                  className="d-flex px-2 py-2 border mb-2 align-items-center profile-card"
                  
                  onClick={() => handleSelectChange(item)}
                  style={{
                    gap : '20px',
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "35px",
                      overflow: "hidden",
                      objectFit: "contain",
                      width: "50px",
                      height: "50px",
                    }}
                  >
                    <GetPrivateBucketMedia
                      image={item?.photo}
                      className={"profile-image-size"}
                    />
                  </div>
                  <div>
                    <h6 className="m-0">{item?.name}</h6>
                    <p className="mb-1">{item?.email}</p>
                  </div>
                </div>
              );
            })}
        </CModalBody>
      </CModal>
    </div>
  );
};

export default LoginForm;
